import { render, staticRenderFns } from "./taskLists.vue?vue&type=template&id=2dbbcdbe&scoped=true&"
import script from "./taskLists.vue?vue&type=script&lang=js&"
export * from "./taskLists.vue?vue&type=script&lang=js&"
import style0 from "./taskLists.vue?vue&type=style&index=0&id=2dbbcdbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbbcdbe",
  null
  
)

export default component.exports